
class CustomContent extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.showSection = this.querySelector("[data-show-section]")?.dataset.showSection;
    this.handleSectionVisibility(this.showSection);
  }

  handleSectionVisibility(showSection) {
    const section = this.querySelector("section");
    if (!section) return;

    // If the block that contains the section visibility toggle does not exist, display the section
    if (!showSection || showSection == 'true') section.classList.remove("d-none");
  }
}

customElements.define("custom-content", CustomContent);
